import Card from '@/components/Card';
import ChatMessage from '@/components/ChatMessage';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';
import { useAdditionalInfoContext } from '@/features/v2/lib/additionalInfo';

import { useLingui } from '@lingui/react';

export const DAMAGE_PHOTOS_NAME = 'damage_photos';

const DamagePhotos = () => {
  const { i18n } = useLingui();
  const { withDamagePhotosRequired } = useAdditionalInfoContext();
  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać zdjęcia uszkodzeń?'),
    description: i18n.t(
      'Zadbaj o to, by zdjęcia były wyraźne i dokumentowały wszystkie widoczne uszkodzenia.'
    ),
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Zdjęcia uszkodzeń')}
          instructionProps={instructionProps}
          inputFieldName={DAMAGE_PHOTOS_NAME}
          required={withDamagePhotosRequired}
          attachmentTypeId={ATTACHMENT_TYPES.ZDJECIE_USZKODZEN}
        />
      </Card>
      {withDamagePhotosRequired ? null : (
        <ChatMessage
          variant="secondary"
          className="mt-3 lg:mt-5"
          description={i18n.t(
            'Jeśli posiadasz zdjęcia uszkodzeń pojazdu, to warto je załączyć już teraz. Będą stanowiły dodatkowe źródło informacji dla rzeczoznawcy.'
          )}
        />
      )}
    </div>
  );
};

export default DamagePhotos;
